import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import SectionNav from './SectionNav';


const MainNav = ({ ui, sections, location, subnavOnly }) => {
  const isActivePath = path => location.pathname === path || location.pathname.startsWith(path + '/');

  const activeSectionSlug = sections.navItems.find((slug, i) => isActivePath(`/${i + 1}/${slug}`));
  if (!activeSectionSlug) {
    return null;
  }

  const activeSection = sections.bySlug[activeSectionSlug];
  const activeSectionPath = `/${sections.navItems.indexOf(activeSection.slug) + 1}/${activeSection.slug}`;

  const activeSectionItem = activeSection.items.find(({ uid }) => uid === ui.activeTitle);
  if (activeSectionItem && activeSectionItem.showMainNav === false) {
    return null;
  }

  const showSectionNav = activeSectionItem && activeSectionItem.showSectionNav;
  const sectionNav = <SectionNav section={activeSection} activeItem={activeSectionItem} baseUrl={activeSectionPath} />;

  if (subnavOnly) {
    return showSectionNav ? sectionNav : null;
  } else {
    return (
      <Fragment>
        <nav className="section-nav container-fluid">
          <div className="row">
            {sections.navItems.length !== 0 && sections.navItems.map((item, i) => {
              const { slug, name } = sections.bySlug[item];
              const url = `/${i + 1}/${slug}`;
              return (
                <NavLink className="col" key={slug} to={url}>
                  {name}
                </NavLink>
              );
            })}
          </div>
        </nav>
        {showSectionNav ? sectionNav : null}
      </Fragment>
    );
  }
};

MainNav.propTypes = {
  sections: PropTypes.object.isRequired,
  subnavOnly: PropTypes.bool,
};

const mapStateToProps = ({ ui }) => ({ ui });

export default withRouter(connect(mapStateToProps)(MainNav));



// WEBPACK FOOTER //
// ./src/components/MainNav.js